$(document).ready(function () {
  $(".owl-item.active.center").addClass("selected");

  $(".product-single__thumbnail").on("click touchstart", function () {
    $(".owl-item").removeClass("selected");
    var $clickedThumbnailItem = $(this).closest(".owl-item");
    $clickedThumbnailItem.addClass("selected");
  });

  $("input.clearCart").on("click", function () {
    Shopify.clear(function () {
      window.location = "/cart/clear";
    });
  });

  var links = $("header-area a, .footer-top-area a");
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname.indexOf("www.safetrxapp") > -1) {
      continue;
    }

    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer";
    }
  }

  $(".cart-page .product-quantity-action:hidden")
    .find(".qt")
    .removeAttr("name");

  $(document).on("change", "select[name=country_code]", function () {
    const $this = $(this);
    updateCountryDropdown($this.val(), $this.closest("form"));
  });

  

  $(".newsletter-button").on("click", function (e) {
    showModal('Newsletter');
  });

  $(".view-pdf-modal").on("click", function (e) {
    e.preventDefault();
    showModal('PDF', $(this).attr("href") + "#toolbar=0");
  });

  $("#myPdfModal, #newsletterModal").on("hidden.bs.modal", function () {
    $(this).find("object").remove();
    $(this).find("iframe").remove();
  });

  $(".minicart-close").on("click", function () {
    $(".shopping-cart").removeClass("show");
  });

  $(".shopping-cart").on("mouseover", function () {
    if ($(window).width() < 1100) {
      return;
    }
    $(this).addClass("show");
  });

  $('.select-country-button').on("click", function () {
    $(this).parent().removeClass("active");
    $('.localization-form').addClass("active");
    $('.notify-wrap-mobile').addClass("active");
  });

  updateCountryDropdown();
  initSubscriptionDetails();

  if ($(window).width() < 768) {
    $(".product_details .header").append(
      $(".subscription-provider-details:visible")
    );
  } else {
    $(".product_details_info .header").append(
      $(".subscription-provider-details:visible")
    );
  }
});

function showModal(modalType, url) {
   // Use an object element as this will scale the modal according to device. PDF wil not scale inside an iframe
  var modalContentWrapper = document.createElement("object"),
  // For unsupported browsers we use an iframe
  modalContentWrapperFallback = document.createElement("iframe");
  modalContentWrapper.width = modalContentWrapperFallback.width = "100% ";
  modalContentWrapper.height = modalContentWrapperFallback.height = "800px";

  modalType = modalType || 'PDF';
  const $modalElement = modalType === 'Newsletter' ? $("#newsletterModal") : $("#myPdfModal");
  var modalUrl;

  if (modalType === 'Newsletter') {
    modalUrl = "https://omniform1.com/signup/v1/61aaa840f7860b001f9ed795_6229d1acaadb345f9d931dc3.html";
  } else {
    modalUrl = url;
  }

  modalContentWrapper.data = modalUrl;
  modalContentWrapperFallback.src = modalUrl;
  modalContentWrapper.append(modalContentWrapperFallback);
  $modalElement.find(".modal-body").append(modalContentWrapper);
  $modalElement.modal("show");
}

function getCountrySelectedValue() {
  const $headerArea = $(".header-area", "header"),
    $countryDropdownOptions = $headerArea.find("select[name=country_code]");

  if (!$countryDropdownOptions.length) {
    return;
  }

  return $countryDropdownOptions.val();
}

function setCountrySelectedValue(selectedValue) {
  const $headerArea = $(".header-area", "header"),
    $countryDropdownOptions = $headerArea.find("select[name=country_code]");

  if (
    !$countryDropdownOptions.length ||
    !window.GlobalCountriesJson ||
    !window.GlobalCountriesJson.countries
  ) {
    return;
  }

  $countryDropdownOptions.val(selectedValue);
}

function updateCountryDropdown(selectedCountryValue, localizationForm) {
  if (!selectedCountryValue) {
    selectedCountryValue = getCountrySelectedValue();
  }

  if (selectedCountryValue && localizationForm) {
    if (selectedCountryValue !== "All") {
      localizationForm.trigger("submit");
      return;
    }
  } else {
    if (window.Shopify.country === "IE") {
      const $headerArea = $(".header-area", "header"),
        $countryDropdownOptions = $headerArea.find("select[name=country_code]");

      if (
        $countryDropdownOptions.find('option[value=""],option:not([value])')
          .length === 0
      ) {
        $countryDropdownOptions.prepend(
          '<option value="">Please select Country</option>'
        );
        selectedCountryValue = "";
        setCountrySelectedValue(selectedCountryValue);
      }
    } else {
      const $productDetailsWrapper = $(".product_details_info"),
        $subscriptionBenefitsWrapper = $productDetailsWrapper.find(
          ".subscription-details"
        );
      $("form.cart").removeClass("d-none");
      $subscriptionBenefitsWrapper.removeClass("d-none");
    }
  }

  var $selectedCountryShopUrl = $(
    ".subscription-shop-url[data-country='" + selectedCountryValue + "']"
  );

  if (selectedCountryValue && !$selectedCountryShopUrl.length) {
    return;
  }

  $(".product-actions").hide();
  $(".price-quantity-wrapper").hide();
  $(".subscription-provider-details:visible").hide();
  $(".subscription-details").hide();
  $(".vat-information").hide();

  if (!selectedCountryValue) {
    $(".select-country-wrapper").removeClass("d-none");
    $(".subscription-shop-url").addClass("d-none");
  } else {
    $selectedCountryShopUrl.removeClass("d-none");
    $(".select-country-wrapper").addClass("d-none");
  }
}

function initSubscriptionDetails() {
  const $selectedCountry = getCountrySelectedValue(),
    $productDetailsWrapper = $(".product_details_info"),
    $subscriptionBenefitsWrapper = $productDetailsWrapper.find(
      ".subscription-price-benefits-wrapper"
    );

  if (!$subscriptionBenefitsWrapper.length || !$selectedCountry) {
    return;
  }

  $subscriptionBenefitsWrapper.each(function () {
    $(this).addClass("d-none");
  });

  var $selectedCountrySubscriptionOptions = $(
    ".subscription-price-benefits-wrapper[data-country='" +
      $selectedCountry +
      "']"
  );

  $selectedCountrySubscriptionOptions.removeClass("d-none");

  if (window.Shopify.countryname) {
    $("#address_country").val(window.Shopify.countryname);

    if (
      $(
        "#subscription-countries option[value=" +
          window.Shopify.countryname +
          "]"
      ).length > 0
    ) {
      $("#subscription-countries")
        .val(window.Shopify.countryname)
        .trigger("change");
    }
  }
}
